module.exports = __webpack_public_path__ + "img/note-sample.06163216.jpg";